import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CheckCircle = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M24 11C24 10.448 23.552 10 23 10C22.724 10 22.474 10.112 22.293 10.293L13 19.586L9.707 16.293C9.526 16.112 9.276 16 9 16C8.448 16 8 16.448 8 17C8 17.276 8.112 17.526 8.293 17.707L12.293 21.707C12.488 21.902 12.744 22 13 22C13.256 22 13.512 21.902 13.707 21.707L23.707 11.707C23.888 11.526 24 11.276 24 11Z" />
	</svg>
);

export default CheckCircle;
